import {ActionButton, DynamicCrudService, OggettoConfig} from "src/app/shared/_services/dynamic-crud.service";
import {CampoAggiuntivo} from "../../../app/shared/models/campo-aggiuntivo";
import {ImageCarouselComponent} from "../../../app/shared/Componenti/ImageCarousel/ImageCarouselComponent";
import {ApiPathsService} from "../../../app/api-paths.service";
import {ToastrService} from "ngx-toastr";
import {DynamicEditComponent} from "../../../app/shared/dynamic-edit/dynamic-edit.component";
import {forkJoin} from "rxjs";
import {GetImponibile, idsToBase64, PrezzoIvato} from "./ProductUtility";
import {GetFromLocalStorage} from "../../Utility/Utility";
import {map} from "rxjs/operators";
import {DynamicListComponent} from "../../../app/shared/dynamic-list/dynamic-list.component";
import {MultiSelectComponent} from "../../../LibrerieCustom/MultiselectDropdown";
import {FieldViewerComponent} from "../../../app/shared/field-viewer/field-viewer.component";
import {Injector} from "@angular/core";

function ListaProdotti() {
  var OBJ: OggettoConfig = {
    Id: "lista_prodotti",
    RestRoute: '/prodotti',
    listRoute: 'listMy',
    ListResponseHasData: true,
    ListDefaultFilter: {},
    noActionLabel: true,
    listTitle: 'Prodotti',

    //hasHeader:true,
    Filters: [
      // CampoAggiuntivo.InputField("DATA", 'inizio','date', 'col-lg-2 ', {
      //
      // }),
      // CampoAggiuntivo.InputField("   ", 'fine','date', 'col-lg-2 ', {
      //
      // }),
      // CampoAggiuntivo.SingleDropdown("TIPO", 'tipo', [{id:null, label:'Tutti'},{id:30, label:'B2B'}, {id:31, label:'B2C'}],'label'),
      // CampoAggiuntivo.SingleDropdown("STATO", 'stato_prog', [{id:'T', label:'Tutti'}],'label')
    ],
    PrintHeaders: [],
    asyncFullResponseMap: async (response: any | any[], component?: DynamicListComponent, callBack?: (response) => any) => {
     // var Imgs = await idsToBase64(response.data.map(prod => prod.id_immagine), component.api.getBaseAPI())
      const ids =
        response.data
          .map(prod => prod.id_immagine)
          .filter(id => id);
      let Imgs = [];
      if (ids.length > 0) {
        Imgs = await idsToBase64(
          ids,
          component.api.getBaseAPI()
        );
      }
      let imgIndex = 0;
      response.data = response.data.map((x) => {
        let immagine = null;
        if (x.id_immagine) {
          immagine = Imgs[imgIndex];
          imgIndex++;

        }
        return {
          ...x,
          Immagine: immagine || ''
        };

      });


      response.data = response.data.sort((a,b) =>{
        return Number(b.id) - Number(a.id);
      });
      callBack(response);
    },
    Headers: [
      CampoAggiuntivo.Html("Prodotto", (x) => `<div class="pcell"><div class="pt">${x.Immagine ? `<img class="d-gal-img" src="${x.Immagine}" style="max-width: 50px; max-height: 50px; object-fit: cover">` : ` <div class="no-prod-img">📦</div>`}</div><span class="plink">${x.prodotto}</span></div>`),
      CampoAggiuntivo.Html("Stato", (x) => `<span class="bdg ${x.standby ? 'y' : 'g'}">${x.standby ? 'Standby' : 'PUBLIC'}</span>`),
      CampoAggiuntivo.Html("Marca", (x) => `<span>${x?.marcaObject?.label}</span>`),
      CampoAggiuntivo.Html("Categoria", (x) => `${x.categorie?.map(cat => cat.categoria).join(' / ')}`),
      CampoAggiuntivo.Html("Acquisto €", (x) => `<span class="font-weight-bold">€${PrezzoIvato(parseFloat(x.prezzi.find(y => y.umlabel == 'pz')?.prezzo?.toString() ?? '0'), 22).toDecimals(2)}</span>`),
      CampoAggiuntivo.Html("Vendita €", (x) => `<span class="font-weight-bold color-teal">${x.prezzi?.filter(y => y.umlabel != 'pz')?.map(y => "€" + PrezzoIvato(parseFloat(y.prezzo?.toString()), 22).toDecimals(2)).join(', ')}</span>`),
      CampoAggiuntivo.Html("Promo €", (x) => `<span class="font-weight-bold">${x.promozione?.map(promo => `€${promo.sconto?.find(sc => true)?.prezzo?.toDecimals(2)}`).join(', ')}</span>`),
      CampoAggiuntivo.Html("Creato", (x) => `<span class="font-12 color-muted">${x.data_creazione}</span>`),
    ],
    AzioniLista: [
      ActionButton.FuncButton("edit", (prodotto, api, end, toastr, component: DynamicCrudService) => {
        component.router.navigate(['marketplace/shared/dynamicedit/prodotto/', prodotto?.id])
        //window.location.href = `/marketplace/`;
      }, {
        //svgIcon:`<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>`,
        class: ' ib',
        icon: 'fas fa-pencil',
      }),
      ActionButton.FuncButton("delete", (prodotto, api, onEnd) => {
          if (!confirm("Sei sicuro di voler eliminare il prodotto?")) return;
          api.ClassicPost("/prodotti/delete", prodotto).subscribe(() => {
            if (onEnd) onEnd()
          });
        },
        {
          //svgIcon: `<svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"></path></svg>`,
          class: ' ib',
          icon: 'fas fa-trash-alt',
          noGet: true,
        }
      )
    ],
    MenuItems: [
      {
        path: 'shared/dynamiclist/lista_prodotti',
        title: "Lista Prodotti",
        icon: "fas fa-cart",
        class: "",
        capacita: ['is-venditore'],
      }
    ]
  }
  return OBJ;
}

function Prodotto(): OggettoConfig {
  return {
    Id: 'prodotto',
    RestRoute: '/prodotti',
    MenuItems: [{
      path: 'shared/dynamicedit/prodotto',
      title: "Carica Prodotto",
      icon: "fas fa-cart",
      class: "",
      capacita: ['is-venditore'],
    }],
    EditView: 'Page',
    noCardBody: true,
    asyncMap: (prodotto, component: DynamicEditComponent, callback) => {
      if (!prodotto._campiBaseAdded) {
        prodotto.campi = [
          CampoAggiuntivo.InputField("Titolo", "prodotto", "text", "col-lg-12", {
            placeholder: 'Indica chiaramente cosa vendi'
          }),
          CampoAggiuntivo.InputField("Descrivi il tuo articolo", "descrizione", "textarea", "col-lg-12", {
            placeholder: 'Aggiungi più info dettagliate...',
            prevDivClass: 'vf-divider'
          }),
          ...(prodotto.campi ?? []),
        ];

        prodotto._campiBaseAdded = true;
      }
      prodotto.categorieObject = [...(prodotto?.categorie ?? [])];

        prodotto.categorie= prodotto.categorie?.map(x => x.id);
        prodotto.colore = [...(prodotto.coloreObject || [])];
        prodotto.coloreId = (prodotto.coloreObject || []).map(c => c.id);
      console.log("coloreObject", prodotto.coloreObject);
      console.log("colore iniziale", prodotto.colore);
      console.log("coloreId iniziale", prodotto.coloreId);
        prodotto._categoriaLoaded = JSON.stringify(prodotto.categorie);
        prodotto.esclusiva = component.authSvc?.currentUserValue?.id;
        prodotto.esclusivaObject = component.authSvc?.currentUserValue;
    prodotto.DropdownSources= prodotto.DropdownSources ?? {}

      var RequestsType = [
        {
          link: '/prodotti/categorie/list',
          postParams: {},
          name: 'cats',
        },
        {
          link: '/prodotti/taglia/list',
          postParams: {page: 0, size: 10},
          name: 'taglie'
        },
        {
          link: '/prodotti/colori/list',
          postParams: {},
          name: 'colori'
        },
        {
        link: "/prodotti/um",
          name: 'ums'
        },
        {
          link: '/progetti/costi/retail',
          name: 'retail'
        }
      ];

      var requests = RequestsType.map(type=> (type.postParams ? component.api.ClassicPost(type.link, type.postParams) : component.api.ClassicGet(type.link)).pipe(map(result => {
        var out: any = {}
        out[type.name] = result
        return out;
      })))

      forkJoin(requests).subscribe(data => {
        data.forEach(requestOut =>{
          if(requestOut.cats){
            prodotto.DropdownSources.catSource = prodotto.categorieObject?.figli ?? requestOut.cats
            prodotto.OriginalCatList = requestOut.cats;
          }
          if(requestOut.taglie){
            prodotto['DropdownSources'] = prodotto['DropdownSources'] ?? {};
            const taglieOrdinate = (requestOut.taglie.data || [])
              .map(y => ({
                ...y,
                magazzino:
                prodotto?.taglie?.find(
                  t => t.id == y.id
                )?.magazzino
              }))
              .sort(
                (a, b) =>
                  Number(a.ordine || 0) -
                  Number(b.ordine || 0)
              );
            prodotto['DropdownSources']['Taglie'] = taglieOrdinate;
            prodotto.taglie = [...(prodotto.taglie || [])].sort(
              (a,b) =>
                Number(a.ordine || 0) -
                Number(b.ordine || 0)
            );
          }
          if(requestOut.colori){
            prodotto['DropdownSources'] = prodotto['DropdownSources'] ?? {};
            prodotto['DropdownSources']['Colori'] = requestOut.colori.data || requestOut.colori;
          }
          if (requestOut.retail) {
            prodotto.moltiplicatoreRetail = parseFloat(
              requestOut.retail[0]?.codice?.toString().replace(',', '.') ?? '1'
            );
          }
          if(requestOut.ums){
            var ums = requestOut.ums;


          var umsValide = ums.filter(um => um.label !== 'pz');

          function isEnabled(um, i) {
            return i == 0
          }

          prodotto['UMS'] = ums;
          prodotto['UmsValide'] = umsValide.map((um, i) => {
            return {...um, enabled: isEnabled(um, i)}
          });

          ums.forEach(um => {
            prodotto[`prezzo_${um.label}`] = PrezzoIvato(parseFloat(prodotto.prezzi?.find(p => p.um == um.id)?.prezzo?.toString() ?? '0') ?? 0, 22);
            var promo = prodotto?.promozione?.find(p => p.tipo == um.label);
            if (promo) {
              prodotto[`sconto_${um.label}`] = promo.sconto.find(sc => true).prezzoNetto;
              prodotto[`inizio_sconto_${um.label}`] = promo.data;
              prodotto[`fine_sconto_${um.label}`] = promo.dataScadenza;
            }
          })
          prodotto.PrezziFields = umsValide.map((um, i) => {

            return CampoAggiuntivo.InputField(
              `Prezzo ${component.translate.instant(um.label.toLowerCase())}`,
              `prezzo_${um.label}`,
              "euro",
              `col-lg-${umsValide.length < 5 ? (12 / umsValide.length) : '6'}  ${isEnabled(um, i) ? '' : 'disabled'}`,
              {
                prevDivClass:
                  um.label === 'B2B'
                    ? 'retailer-consigliato'
                    : '',
                disabledif: {func: (x) => isEnabled(um, i)},
                data_type: 'euro',
                OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {
                  if (!isEnabled(um, i)) return;

                  prodotto[`prezzo_${um.label}`] = selected;

                  if (um.label === 'B2B') {
                    prodotto['prezzo_B2C'] =
                      parseFloat(selected?.toString().replace(',', '.') || '0') *
                      parseFloat(prodotto.moltiplicatoreRetail?.toString().replace(',', '.') || '1');
                  }
                }
              })
          })
          prodotto.ScontiFields = umsValide.map((um, i) => {
            // prodotto[`sconto_${um.label}`] = '25.00';
            CalcolaSconto(um);

            function CalcolaSconto(um) {
              var sconto = parseFloat(prodotto[`sconto_${um.label}`]?.toString() ?? '0');
              prodotto[`prezzo_${um.label}_scontato`] = prodotto[`prezzo_${um.label}`] - ((prodotto[`prezzo_${um.label}`] / 100) * sconto);
            }

            return CampoAggiuntivo.InputField("", "PrezziFields", "ArrayCampiAggiuntivi", `prodotto-sconti-box color-${um.label?.toLowerCase()}`, {
              type: "ArrayCampiAggiuntivi",
              campiAggiuntivi: [
                CampoAggiuntivo.Html("", (x, parent) => `
                  <div class="vf-discount-header">
                    <span class="icon-tag"></span>
                    Sconto ${parent.translate.instant(um.label)}
                    <span class="optional">(opzionale)</span>
                  </div>
                `, () => true, {class: 'col-lg-12'}),
                CampoAggiuntivo.InputField("Sconto %", `sconto_${um.label}`, "number", "col-lg-3", {
                  OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {
                    CalcolaSconto(um);
                  },
                  data_type: 'sconto'
                }),
                CampoAggiuntivo.InputField(`Prezzo ${component.translate.instant(um.label.toLowerCase())} base`, `prezzo_${um.label}`, "number", "col-lg-5 disabled", {
                  disabledif: {func: (x) => false},
                  data_type: 'euro'
                }),
                CampoAggiuntivo.InputField(`Prezzo ${component.translate.instant(um.label.toLowerCase())} scontato`, `prezzo_${um.label}_scontato`, "number", "col-lg-4 disabled", {
                  disabledif: {func: (x) => false},
                  data_type: 'euro'
                }),
                CampoAggiuntivo.InputField("Inizio sconto", `inizio_sconto_${um.label}`, "date", "col-lg-6", {
                  OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {

                  }
                }),
                CampoAggiuntivo.InputField("Fine sconto", `fine_sconto_${um.label}`, "date", "col-lg-6", {
                  OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {

                  }
                })
              ]
            });
          })}
        })
        prodotto.colore =
          [...(prodotto.coloreObject || [])];

        prodotto.coloreId =
          (prodotto.coloreObject || []).map(c => c.id);
        callback(prodotto);
      })
    },
    CustomValidate:(x,component)=>{
      var valid = x.prodotto?.length  && x.categorie?.length &&  x.descrizione && x.taglie?.length && (x.colore?.length || x.coloreObject?.length) && (x.immagine || x.Immagini?.length || x.id_immagine) && x.stagione && x.prezzo_pz && x.marca;
      if(!valid) {
        component.Toastr.error("Attenzione Inserire tutti i campi obbligatori");
        console.log("Prodotto: ", x)
        console.log("prodotto:", x.prodotto);
        console.log("categorie:", x.categorie);
        console.log("descrizione:", x.descrizione);
        console.log("taglie:", x.taglie);
        console.log("colore:", x.colore);
        console.log("Immagine:", x.Immagini);
        console.log("stagione:", x.stagione);
        console.log("prezzo_pz:", x.prezzo_pz);
        console.log("marca:", x.marca);

        return false
      }
     return true;
    },
    sezioni: [
      {
        sezione: 'Vendi un articolo',
        class: 'prodotto-edit-view',

        campi: [

              {
                nome:"Immagine",
                type:'component',
                hideif:{fieldnotexist:'PrezziFields'},
                component: ImageCarouselComponent,
                modificabile:false,
                class:'col-lg-12',
                oggetti:['test'],
                func:(oggetto, component: FieldViewerComponent)=>{
                  var injector = Injector.create({
                   providers:[
                     {
                       provide: 'Oggetto',
                       useValue: oggetto
                     }
                   ],




                    parent: component.injector
                  });
                  return {  injector:injector };
                },

              },
          CampoAggiuntivo.InputField("Titolo", "campi", "ArrayCampiAggiuntivi", "prodotto-field", {
            placeholder: 'Indica chiaramente cosa vendi',
            type: "ArrayCampiAggiuntivi",
          }),
          CampoAggiuntivo.SingleDropdown(
            "Categoria",
            "categorie",
            'catSource',
            "categoria",
            {
              parameter: [],

              OnChangeFunc: (
                prodotto,
                selected?,
                api?: ApiPathsService,
                toastService?: ToastrService
              ) => {

                const categoriaId =
                  Array.isArray(prodotto.categorie)
                    ? prodotto.categorie?.[0]
                    : prodotto.categorie;

                if (!categoriaId) {

                  prodotto.DropdownSources.Taglie = [];
                  prodotto.taglie = [];

                  return;
                }

                api.ClassicPost(
                  '/prodotti/taglia/list',
                  {
                    page: 0,
                    size: 100,
                    cat_id: categoriaId
                  }
                ).subscribe((res: any) => {

                  prodotto.DropdownSources = prodotto.DropdownSources || {};
                  const taglieOrdinate = (res.data || [])
                    .map(taglia => ({
                      ...taglia,
                      magazzino:
                        prodotto?.taglie?.find(
                          t => t.id == taglia.id
                        )?.magazzino
                    }))
                    .sort(
                      (a, b) =>
                        Number(a.ordine || 0) -
                        Number(b.ordine || 0)
                    );
                  prodotto.DropdownSources.Taglie = taglieOrdinate;
                  prodotto.taglie = [...(prodotto.taglie || [])].sort(
                    (a, b) =>
                      Number(a.ordine || 0) -
                      Number(b.ordine || 0)
                  );

                  const categoriaCorrente =
                    JSON.stringify(prodotto.categorie);

                  const isPrimaInit =
                    prodotto._categoriaLoaded === categoriaCorrente;

                  if (!isPrimaInit) {
                    prodotto.taglie = [];
                    prodotto.taglieId = [];
                  }

                });

              }

            },
            'prodotto-brand',
            () => true,
            {
            dataLabel: "Categoria",
            singleSelection: true,
            singleOutput: false,
            closeDropDownOnSelection:true,
            isTreeNav:true,
            HtmlTemplate: (x:any, component: MultiSelectComponent)=> {
              var icon = '';
              if(!x.figlio){
                switch (x.categoria?.toLowerCase()) {
                  case 'uomo' || 'men':
                    icon = '👔 ';
                    break;
                  case 'teen' || 'teen':
                    icon = '🧑 ';
                    break;
                  case 'bambino' || 'baby':
                    icon = '🧑 ';
                    break;
                  case 'donna' || 'women':
                    icon = '👗 ';
                    break;
                  default:
                      icon = '⚤ '
                    break;
                }

              }
              return`
                <div class="d-flex justify-content-between align-items-center h-100 vf-dd-item">
                    <span>${icon}${x.categoria}</span>
                    ${x.figli?.length ? '<span> > </span>' : ''}
                </div>
            `
            },
            HtmlHead:(component: MultiSelectComponent)=>{
              const isBase = !component.filter['figli'] && !component.filter['categoria'];
              return `
                <div class="vf-dd-group-lbl">${isBase? 'Seleziona il genere' : 'categoria'}</div>
              `
            }
          }),
          CampoAggiuntivo.SingleDropdown("Marca", "marca", '', "label", {
            source: '/settings/get',
            parameter: [{nome: 'id', value: 'marca_prodotto'}, {nome: 'type', value: 'marca_prodotto'}],
            onMore: (x, api: ApiPathsService, permission, campo, callback: (x) => void) => {
              api.ClassicPost('/settings/add', {label: x.label, type: 'marca_prodotto'}).subscribe(data => {
                if (!data?.id) return;
                callback(data);
              });
            }
          }, 'prodotto-brand', () => true, {
            dataLabel: "Brand",
            moreButton: true,
            moreButtonText: "Inserisci",
          }),
          CampoAggiuntivo.SingleDropdown("Taglie", "taglie", 'Taglie', "taglia", {

            internalOutput: `taglie`,
            OutputField: 'taglieId',
          }, 'prodotto-brand', () => true, {
            dataLabel: "Taglie disponibili",
            singleOutput: false,
            singleSelection: false,
            allowSearchFilter: false,
            campiAggiuntivi: [
              CampoAggiuntivo.InputField("Magazzino", "magazzino", "number", "", {
                min: 0,
                style: {'width': '240px'},
              })
            ]
          }),
          CampoAggiuntivo.SingleDropdown("Colori", "colore", 'Colori', "check", {

            internalOutput: 'colore',
            OutputField: 'coloreId',
            responseHasData: true,
            placeholder: 'Seleziona massimo 2 colori',
            OnChangeFunc: (prodotto, selected) => {

              if(
                !selected?.length &&
                prodotto.coloreObject?.length &&
                !prodotto._coloriInitialized
              ){

                prodotto._coloriInitialized = true;

                prodotto.colore =
                  [...prodotto.coloreObject];

                prodotto.coloreId =
                  prodotto.coloreObject.map(c => c.id);

                return;
              }

            },
          }, 'prodotto-brand', () => true, {
            dataLabel: "Colore",
            singleOutput: false,
            singleSelection: false,
            allowSearchFilter: true,
            enableCheckAll:false,
            itemsShowLimit: 2,
            limitSelection: 2,
            searchPlaceholderText: 'Cerca colore...',
          }),
          CampoAggiuntivo.InputField("", "campi", "ArrayCampiAggiuntivi", "prodotto-field mt-20", {
            type: "ArrayCampiAggiuntivi",
            campiAggiuntivi: [
              CampoAggiuntivo.SingleDropdown("Collezione", "stagione", '/prodotti/stagioni/list', "check", {
                parameter: [],
                responseHasData: true,
                OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {
                  if(prodotto.stagioneObject?.codice)
                  prodotto['prezzo_B2B'] = (prodotto['prezzo_pz'] ?? 0) * parseFloat(prodotto.stagioneObject?.codice ?? '0');
                  prodotto['prezzo_B2C'] = prodotto['prezzo_B2B'] * parseFloat(prodotto.moltiplicatoreRetail?.toString().replace(',', '.') || '1');
                }
              }, 'prodotto-collezione', () => true, {
                allowSearchFilter: false,
                dataLabel: "Collezione",
              }),
              CampoAggiuntivo.InputField(`Prezzo di acquisto`, `prezzo_pz`, "number", "col-lg-12 ", {
                data_type: 'euro',
                prevDivClass: 'vf-divider',
                OnChangeFunc: (prodotto, selected?, api?: ApiPathsService, toastService?: ToastrService) => {
                  if(prodotto.stagioneObject?.codice)
                  prodotto['prezzo_B2B'] = (prodotto['prezzo_pz'] ?? 0) * parseFloat(prodotto.stagioneObject?.codice ?? '0');
                  prodotto['prezzo_B2C'] = prodotto['prezzo_B2B'] * parseFloat(prodotto.moltiplicatoreRetail?.toString().replace(',', '.') || '1');
                }
              }),
              CampoAggiuntivo.Html(
                '',
                () => `
    <div style="
      margin-top:-10px;
      font-size:12px;
      color:#6c757d;
      font-style:italic;
    ">
      (IVA inclusa)
    </div>
  `,
              ),
            ]
          }),
          CampoAggiuntivo.InputField("", "PrezziFields", "ArrayCampiAggiuntivi", "prodotto-prezzo-box", {
            type: "ArrayCampiAggiuntivi",
          }),
          CampoAggiuntivo.InputField("", "ScontiFields", "ArrayCampiAggiuntivi", "col-lg-12", {
            type: "ArrayCampiAggiuntivi",
            style: {
              'padding-inline': '12px'
            }
          }),
          CampoAggiuntivo.InputField("Stato", 'standby', 'checkbox', 'prodotto-stato', {
            inputClass: 'toggle-vis'
          })
        ],
      }
    ],
    customSave: (x, api, callback, bup, toastrService) => {
      var prezzi = [];
      x['UMS'].forEach(um => {
        var imponibile = GetImponibile(x[`prezzo_${um.label}`], 22);
        if (imponibile) {
          prezzi.push({prezzo: imponibile, iva: 22, um: um.id})
          if (um.label == 'pz') {
            x['costo'] = imponibile;
          }
        }
      })
      x.prezzi = prezzi;
      const coloriFinali =
        x.colore?.length
          ? x.colore
          : x.coloreObject || [];
      x.colore = coloriFinali.map(c => c.id ?? c);
      x.idMarca = x.marca;
      console.log(x);
      if (!x.prezzi?.every(prezzo => prezzo.prezzo && prezzo.um)) {
        toastrService.error('Inserisci tutti i prezzi e le unità di misura');
        callback(x);
        return;
      }
      if (!x.prodotto) {
        toastrService.error('Inserisci il titolo del prodotto');
        callback(x);
        return;
      }

      const scontoNonValido = x['UMS']?.some(um => {
        const sconto = x[`sconto_${um.label}`];
        const inizio = x[`inizio_sconto_${um.label}`];
        const fine = x[`fine_sconto_${um.label}`];

        return sconto && (!inizio || !fine);
      });

      if (scontoNonValido) {
        toastrService.error('Compila i campi dello sconto');
        setTimeout(() => {
          callback(x);
        }, 0);
        return;
      }


      if (!x.id_immagine && !x.immagine && x.ImmaginiBase64?.length) {
        x.immagine = x.ImmaginiBase64[0].immagine;
        x.file = x.ImmaginiBase64[0].filename;

        x.ImmaginiBase64.splice(0, 1);
        x.Immagini.splice(0, 1);
      }
      x.tipo = 68;
      const taglieSelezionate =
        x.taglieId?.length
          ? x.taglieId
          : (x.taglie || []).map(t => t.id ?? t);

      x.taglie =
        (x.DropdownSources?.Taglie || [])
          .filter(taglia => taglieSelezionate.includes(taglia.id))
          .map(taglia => ({
            ...taglia,
            magazzino: Number(taglia.magazzino ?? 0)
          }));

      api.ClassicPost(`/prodotti/${x.id ? 'update' : 'add'}`, x).subscribe(newProdotto => {
        x.immagine = null;
        x.file = null;

        if (newProdotto?.id_immagine) {
          x.id_immagine = newProdotto.id_immagine;
        }

        x._coverUpdatedAt = new Date().getTime();
        if (!x.id) {
          x.id = newProdotto.id;
        }
        if (x.Immagini?.filter(immagine => !immagine.loaded)?.length) {

          var requests = x.Immagini.filter(immagine => !immagine.loaded).map(immagine => {
            var _form = new FormData();
            _form.append("id", x.id);
            _form.append("allegato", immagine);
            return api.MultipartPost(_form, `/prodotti/file`)
          })
          forkJoin(requests).subscribe(data => {
            DeleteImages();
          })
        } else
          DeleteImages();

        function AfterImage() {
          if (x['UMS'].filter(um => x[`inizio_sconto_${um.label}`] && x[`prezzo_${um.label}`] && x[`sconto_${um.label}`])?.length)
            sendListino()
          else
            callback(x)
        }
        function DeleteImages() {

          console.log("DELETE START");
          console.log("ImmaginiDelete", x.ImmaginiDelete);

          if (!x.ImmaginiDelete?.length) {
            AfterImage();
            return;
          }

          const deleteRequests =
            x.ImmaginiDelete.map(id => {

              return api.ClassicPost(
                '/file/delete',
                { id }
              );

            });

          forkJoin(deleteRequests).subscribe(() => {

            console.log(
              "DELETE COMPLETATO"
            );

            AfterImage();

          }, () => {
            AfterImage();
          });
        }
        function sendListino() {
          var ListinoRequests = x['UMS'].filter(um => x[`inizio_sconto_${um.label}`] && x[`prezzo_${um.label}`] && x[`sconto_${um.label}`]).map(um => {
            var promo = x.promozione?.find(promo => promo.tipo == um.label)

            return api.ClassicPost(`/prodotti/listino/${promo ? 'update' : 'add'}`, {
              id: promo?.id,
              data: x[`inizio_sconto_${um.label}`],
              id_fornitore: x['esclusiva'],
              dataScadenza: x[`fine_sconto_${um.label}`],
              tipo: um.label,
            }).pipe(map(x => {
              return {um, listino: x}
            }))
          })
          forkJoin(ListinoRequests).subscribe((data: { um, listino }[]) => {
            var AddProdotto = data.map(list => {
              var promo = x.promozione?.find(promo => promo.tipo == list.um.label)
              var id_pListino = promo?.sconto?.find(x => true)?.id;
              return api.ClassicPost('/prodotti/listino/prodotti/' + (id_pListino ? 'update' : 'add'), {
                id: id_pListino,
                "id_listino": list.listino.id,
                "id_prodotto": x.id,
                "prezzo": x[`prezzo_${list.um.label}_scontato`],
                "prezzoNetto": x[`sconto_${list.um.label}`],
                "codice_produttore": "cod"
              })
            })
            forkJoin(AddProdotto).subscribe(() => {
              callback(x)
            }, () => {
              callback(x)
            })

          })

        }
      })

    }
  }
}


export var ListaProdottiEnv = () => {
  var env: any = {
    Modules: {
      "Lista Prodotti": true
    },
    Cruds: [ListaProdotti(), Prodotto()],
    Menu: [...ListaProdotti().MenuItems, ...Prodotto().MenuItems]
  }
  return env;

}
